'use strict';

var isPhantomJs = /phantomjs/i.test(window.navigator.userAgent);

if (isPhantomJs) {
    require('phantomjs-polyfill'); // adds Function.prototype.bind()
}

module.exports = {
    isPhantomJs: function isPhantomJs() {
        return isPhantomJs;
    }
};
